<template>
  <div>
    <calendar-view
      :events="events"
      :show-date="showDate"
      :enable-drag-drop="false"
      :starting-day-of-week="1"
      :disable-past="true"
      event-top="25px"
    >
      <div
        slot="header"
        slot-scope="{ headerProps }"
        class="text-center mb-5"
        @input="setShowDate()"
      >
        <div class="d-inline-flex align-items-center">
          <button
            type="button"
            :disabled="!headerProps.previousPeriod"
            class="mt-1"
            @click.prevent="setShowDate(headerProps.previousPeriod)"
          >
            <i class="icon-arrow-long-left icon-xsm"></i>
          </button>

          <h6
            slot="label"
            class="font-weight-light text-darker text-uppercase ls-04 mx-5"
          >
            {{ headerProps.periodLabel }}
          </h6>

          <button
            type="button"
            :disabled="!headerProps.nextPeriod"
            class="mt-1"
            @click.prevent="setShowDate(headerProps.nextPeriod)"
          >
            <i class="icon-arrow-long-right icon-xsm"></i>
          </button>
        </div>
      </div>

      <div
        slot="dayContent"
        :ref="formatDay(day)"
        slot-scope="{ day }"
        class="day-card"
        :class="{ 'small-device': viewportWidth <= 991 }"
      >
        <!-- <button
          type="button"
          :disabled="
            isReserved(day, 'morning') ||
            isReserved(day, 'evening') ||
            isReserved(day, 'all-day')
          "
          class="btn-all-day"
          @click="openBookModal(day, 'all-day')"
          @mouseenter="onMouseEnterAllDay(formatDay(day))"
          @mouseleave="onMouseLeaveAllDay(formatDay(day))"
        >
          <span>BOOK</span>
          <p class="day-number">{{ day.getDate() }}</p>
          <span>ALL DAY</span>
        </button> -->

        <div class="text-all-day">
          <span class="month">{{ day.toLocaleString("default", { month: 'short' }) }}</span>
          <p class="day-number">{{ day.getDate() }}</p>
          <span class="day">{{ day.toLocaleDateString("default", { weekday: 'short' }) }}</span>
        </div>

        <button
          type="button"
          :disabled="isReserved(day, 'all-day')"
          class="btn-all-day-xs"
          @click="openBookModal(day, null)"
        >
          <span
            v-if="isReserved(day, 'morning')"
            class="reserved-morning"
          ></span>
          <span
            v-if="isReserved(day, 'evening')"
            class="reserved-evening"
          ></span>
          <p class="day-number">{{ day.getDate() }}</p>
        </button>

        <div class="btns-book-calendar-wrapper">
          <p class="book">BOOK FOR:</p>

          <button
            type="button"
            :disabled="isReserved(day, 'morning') || isReserved(day, 'all-day')"
            class="btn-book-calendar"
            @click="openBookModal(day, 'morning')"
          >
            <span>MORNING</span>
          </button>

          <button
            type="button"
            :disabled="isReserved(day, 'evening') || isReserved(day, 'all-day')"
            class="btn-book-calendar"
            @click="openBookModal(day, 'evening')"
          >
            <span>EVENING</span>
          </button>

          <button
            type="button"
            :disabled="isReserved(day, 'morning') || isReserved(day, 'evening') || isReserved(day, 'all-day')"
            class="btn-book-calendar"
            @click="openBookModal(day, 'all-day')"
          >
            <span>ALL DAY</span>
          </button>
        </div>
      </div>

      <div slot="event" class="d-none"></div>
    </calendar-view>

    <div class="memo d-sm-none mt-5 px-sm-0 px-2">
      <div class="block">
        <span class="icon"></span>
        <p>ALL-DAY RESERVED</p>
      </div>

      <div class="block">
        <span class="icon icon-morning"></span>
        <p>MORNING RESERVED</p>
      </div>

      <div class="block">
        <span class="icon icon-evening"></span>
        <p>EVENING RESERVED</p>
      </div>
    </div>
  </div>
</template>

<script>
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar";

import events from "./data/events";

export default {
  components: {
    CalendarView,
    CalendarViewHeader,
  },
  props: {
    timetableitems: {
      type: Array,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      viewportWidth: window.innerWidth,
      events: this.timetableitems ? this.timetableitems : events,
      showDate: new Date(),
    };
  },
  methods: {
    setShowDate(d) {
      this.showDate = d;
    },
    formatDay(day) {
      const dtf = new Intl.DateTimeFormat("en", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });

      const [{ value: mo }, , { value: da }, , { value: ye }] =
        dtf.formatToParts(day);

      return `${ye}-${mo}-${da}`;
    },
    formatDay2(day) {
      const dtf = new Intl.DateTimeFormat("en", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        weekday: "long",
      });

      const [{ value: we }, , { value: mo }, , { value: da }, , { value: ye }] =
        dtf.formatToParts(day);

      return `${we} ${da}/${mo}/${ye}`;
    },
    openBookModal(day, timeOfDay) {
      Vue.prototype.$date = this.formatDay2(day);
      Vue.prototype.$timeOfDay = timeOfDay;
      Vue.prototype.$timeOfDayReserved = null;

      if (this.isReserved(day, "morning")) {
        Vue.prototype.$timeOfDay = "evening";
        Vue.prototype.$timeOfDayReserved = "morning";
      }

      if (this.isReserved(day, "evening")) {
        Vue.prototype.$timeOfDay = "morning";
        Vue.prototype.$timeOfDayReserved = "evening";
      }

      if (this.isReserved(day, "all-day")) {
        Vue.prototype.$timeOfDay = null;
        Vue.prototype.$timeOfDayReserved = "all-day";
      }

      this.$root.$refs["book-modal"].show();
    },
    isReserved(day, timeOfDay) {
      let reserved = false;

      const dayFormated = this.formatDay(day);

      this.events.forEach((event) => {
        if (event.startDate === dayFormated && event.classes === timeOfDay) {
          reserved = true;
        }
      });

      return reserved;
    },
    onMouseEnterAllDay(ref) {
      this.$refs[ref].classList.add("hovered");
    },
    onMouseLeaveAllDay(ref) {
      this.$refs[ref].classList.remove("hovered");
    },
  },
};
</script>